import React, { FC } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled, { createGlobalStyle } from "styled-components"
import "normalize.css"
import sberLogo from "../static/images/logo.svg"
import { Header } from "./header"
import { Footer } from "./footer"

const GlobalStyle = createGlobalStyle`
  ul,
  li,
  p,
  div,
  img,
  nav,
  form,
  table {
    margin: 0;
    padding: 0;
  }

  body, * {
    font-size: 14px;
    line-height: 20px;
    font-family: "SB Sans Interface", Roboto, sans-serif, arial;

    color: #2C3136;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #333F48;
    font-family: "SB Sans Display", Roboto, sans-serif, arial;
    margin: 0;
  }

  h1 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;

    @media screen and (min-width: 768px) {
      font-size: 28px;
      line-height: 38px;
    }

    @media screen and (min-width: 1200px) {
      font-size: 48px;
      line-height: 56px;
    }
  }

  h2 {
    font-size: 22px;
    line-height: 28px;
    font-weight: 400;
    margin: 0 0 16px 0;

    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 32px;
    }

    @media screen and (min-width: 1200px) {
      font-size: 32px;
      line-height: 40px;
      margin: 0 0 24px 0;
    }

    @media screen and (max-width: 768px) {
      font-weight: 600;
      font-size: 20px;
    }
  }

  h3 {
    font-size: 20px;
    line-height: 28px;

    @media screen and (min-width: 1200px) {
      font-size: 24px;
    }

    font-weight: 400;
    margin: 0 0 24px 0;
  }

  h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    font-family: "SB Sans Interface", Roboto, sans-serif, arial;
  }

  ul {
    list-style: none;
  }

  button,
  .promo__button {
    padding: 15px 20px;
    
    border: none;
    border-radius: 4px;
   
    font-size: 17px;
    line-height: 26px;
    font-weight: 600;

    background-color: #262626;
    color: #fff;

    cursor: pointer;

    &:hover {
      text-decoration: none;
      background-color: #18BB4F;
      outline: none;
    }

    &:focus {
      text-decoration: none;
      background-color: #15A144; 
      outline: none;
    }
  }
  
  .promo__button {
    @media screen and (max-width: 1023px) {
      width: 100%;
      max-width: 84%;
    }

    @media screen and (min-width: 768px) {
      max-width: 65%;
    }
  }

  a {
    color: #18BB4F;
    text-decoration: none;

    &:focus,
    &:hover {
      text-decoration: underline;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: #262626;
  }
`

const Main = styled.main`
  position: relative;
`

const Layout: FC = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <GlobalStyle />
      <Header
        logo={<img src={sberLogo} alt="logo" />}
        number="8 (495) 784-73-70"
      />
      <Main>{children}</Main>
      <Footer />
    </>
  )
}

export default Layout
